import styled from 'styled-components';
import { ReactNode } from 'react';

import { MlbFooter, MlbHeader } from '..';

export interface LayoutProps {
  children: ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  hideFooterLegalText?: boolean;
}

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-self: center;
  width: 48rem;

  @media screen and (min-width: 768px) and (max-width: 900px) {
    width: 46rem;
  }

  @media screen and (min-width: 600px) and (max-width: 767px) {
    width: 35.5rem;
  }

  @media screen and (max-width: 599px) {
    padding: 0 0.5rem;
    width: auto;
  }
`;

export const Layout = ({
  children,
  hideHeader = false,
  hideFooter = false,
  hideFooterLegalText = true,
}: LayoutProps) => (
  <StyledLayout>
    {!hideHeader && <MlbHeader />}
    <Main>{children}</Main>
    {!hideFooter && <MlbFooter hideLegalText={hideFooterLegalText} />}
  </StyledLayout>
);

export default Layout;
